import { blogPosts } from "@/data/blog-posts";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export function PromoAside() {
  const featured = blogPosts[0];
  return (
    <aside className="hidden xl:block w-[320px] min-h-[400px]">
      <div className="flex flex-col justify-between rounded-2xl bg-n-green-h-light p-5 h-full">
        <h3 className="text-2xl font-extrabold leading-tight text-n-text-green">
          Somos o primeiro e-commerce nacional de logística automotiva!
        </h3>
        <div className="mt-6">
          <p className="text-sm font-medium text-n-text-green">
            Veja em nosso blog:
          </p>
          <div className="mt-3 rounded-xl border bg-white p-3">
            <img
              src={featured.image}
              alt={featured.title}
              width={272}
              height={120}
              className="h-28 w-full rounded-md object-cover"
            />
            <div className="mt-3 space-y-1">
              <p className="font-semibold text-n-text line-clamp-2">{featured.title}</p>
              <p className="text-sm text-n-text-neutral line-clamp-2">
                {featured.excerpt}
              </p>
              <Link
                to={`/blog/${featured.slug}`}
                className="text-sm font-medium text-n-text-green underline"
              >
                Leia mais
              </Link>
            </div>
          </div>
          <Link
            to="/blog"
            className="mt-4 inline-flex items-center text-sm font-semibold text-n-text-green"
          >
            Veja nosso blog <ChevronRight className="ml-1 h-4 w-4" />
          </Link>
        </div>
      </div>
    </aside>
  );
}
